export { default, FieldOneLogoSvg } from './FieldOneLogoSvg';